import React, { useState, useEffect, useRef } from "react";
import TimeField from "react-simple-timefield";
import useTranslation from "../i18n/useTranslation";

export default function Form(props) {
   const { t } = useTranslation();
   const { handleRemove, formId, data, handleChange } = props;

   const newFormRef = useRef(null);

   const [comment, setComment] = useState(data.uwagi || "");
   const [timepickerData, setTimepickerData] = useState({
      display: false,
      inputId: ""
   });

   useEffect(() => {
      newFormRef.current && newFormRef.current.select();
   }, []);

   const onCommentBlur = () => {
      handleChange(formId, { uwagi: comment });
   };

   const onHourChange = (hour) => {
      handleChange(formId, hour);
   };

   return (
      <form className="form margin--top form-child">
         <span onClick={() => handleRemove(formId)} className="icon icon-close_icon" />
         <div className="row">
            <div className="col-6 position-relative">
               {timepickerData.display && timepickerData.inputId === "godzOd" ? (
                  <TimeField
                     className="hour-input"
                     value={timepickerData.value || "00:00"}
                     onChange={(event, value) => onHourChange({ [timepickerData.inputId]: value })}
                     autoFocus
                  />
               ) : (
                  <input
                     className="hour-input"
                     autoComplete="off"
                     readOnly
                     id="godzOd"
                     placeholder={t("taskForms.timeFrom")}
                     value={data.godzOd}
                     ref={newFormRef}
                     type="text"
                     onClick={(ev) => setTimepickerData({ display: true, inputId: ev.target.id })}
                  />
               )}
            </div>
            <div className="col-6">
               {timepickerData.display && timepickerData.inputId === "godzDo" ? (
                  <TimeField
                     className="hour-input"
                     value={timepickerData.value || "00:00"}
                     onChange={(event, value) => onHourChange({ [timepickerData.inputId]: value })}
                     autoFocus
                  />
               ) : (
                  <input
                     className="hour-input"
                     autoComplete="off"
                     readOnly
                     id="godzDo"
                     placeholder={t("taskForms.timeTo")}
                     value={data.godzDo}
                     type="text"
                     onClick={(ev) => setTimepickerData({ display: true, inputId: ev.target.id })}
                  />
               )}
            </div>
         </div>
         <div className="margin--top">
            <textarea
               onBlur={onCommentBlur}
               value={comment}
               onChange={(e) => setComment(e.target.value)}
               rows={5}
               placeholder={t("taskForms.notes")}
            />
         </div>
      </form>
   );
}
